import {Component, OnInit, ViewChild} from '@angular/core';
import {FormGroup} from '@angular/forms';
import {MatSort} from '@angular/material/sort';
import {MatTableDataSource} from '@angular/material/table';
import {MatDialog} from '@angular/material/dialog';
import {SnackBarIconService} from '../shared/snack-bar-icon/snack-bar-icon.service';
import {SubscriptionDialogComponent} from './dialogs/subscription-dialog/subscription-dialog.component';
import {SubscriptionsService} from './subscriptions.service';
import {FileService} from '../services/file.service';

@Component({
  selector: 'app-subscriptions',
  templateUrl: './subscriptions.component.html',
  styleUrls: [ './subscriptions.component.scss' ]
})
export class SubscriptionsComponent implements OnInit {

  @ViewChild(MatSort, {static: true}) sort: MatSort;

  public dataSource: MatTableDataSource<any>
  public displayedColumns: string[] = [ 'icon', 'date', 'name', 'validEmail', 'email', 'validCPF', 'cpf', 'export' ];

  public dataSourceStaff: MatTableDataSource<any>
  public displayedColumnsStaff: string[] = [ 'icon', 'date', 'name', 'validEmail', 'email', 'validCPF', 'cpf', 'export' ];

  public count: number;
  public countStaff: number;

  constructor (
    private snackBar: SnackBarIconService,
    private dialog: MatDialog,
    private _subscriptionsService: SubscriptionsService,
    private _fileService: FileService,
  ) {
    this._subscriptionsService.select()
      .subscribe((result) => {
        this.count = 0;
        this.countStaff = 0;
        let array: any[] = []
        result.forEach(element => {

          let cpf = element.payload.doc.data().member_cpf;
          cpf = cpf.split('.').join('');
          cpf = cpf.split(',').join('');
          cpf = cpf.split(';').join('');
          cpf = cpf.split('-').join('');
          cpf = cpf.split(':').join('');
          cpf = cpf.split(' ').join('');

          let email = element.payload.doc.data().member_email;
          email = email.trim();
          email = email.toLowerCase();

          let isValidCPF: boolean = _subscriptionsService.isValidCPF(cpf);
          let isValidEmail: boolean = _subscriptionsService.isValidEmail(email);

          this.count = this.count + 1;

          array.push({
            'id': element.payload.doc.id,
            'date': element.payload.doc.data().date,
            'name': element.payload.doc.data().member_name,
            'member_id': element.payload.doc.data().member_id,
            'email': element.payload.doc.data().member_email.trim(),
            'cpf': cpf.trim(),
            'validCPF': isValidCPF,
            'validEmail': isValidEmail,
          })
        });

        this.dataSource = new MatTableDataSource(array);
        this.dataSource.sort = this.sort;

        let event_ids: string[] = []

        event_ids.push("vXengSavotEedopaxxfO")
        event_ids.push("32An8FerileIhmvFBfUY")
        event_ids.push("VCAKB6uorENn0UXtzVap")
        event_ids.push("jR62yAAgnCerTn3JR57C")

        let arrayStaff: any[] = []

        event_ids.forEach((id) => {
          this._subscriptionsService.selectAgendaStaff(id)
            .subscribe((result) => {
              result.forEach((item) => {

                let staff: any = array.find((e) => {
                  return e.member_id == item.payload.doc.data().member_id
                })

                if (staff) {

                  // console.log("event_name: " + item.payload.doc.data().event_name)
                  // console.log("member_name: " + staff.name)

                  let st: any = {}
                  st = staff;
                  st.event = item.payload.doc.data().event_name
                  // st.activity = item.payload.doc.data().activity_name
                  //  st.topic = item.payload.doc.data().topic_name
                  //  console.log("st.cpf: " + JSON.stringify(st.cpf))

                  //   let stExist: any = arrayStaff.find((e)=>{
                  //       return e.cpf == st.cpf
                  //   })

                  //  if(!stExist){
                  arrayStaff.push(st)
                  this.countStaff = this.countStaff + 1;
                  //  }

                  //  console.log("st: " + JSON.stringify(st))

                } else {
                  //         console.log("nononononononononononono")
                }

                arrayStaff.sort(this.compareNames);

                this.dataSourceStaff = new MatTableDataSource(arrayStaff);
              })
            })
        })

      })

  }

  compareNames (a: any, b: any) {

    const pa = String(a.event + a.name)
    const pb = String(b.event + b.name)

    if (pa > pb) return 1;
    if (pb > pa) return -1;

    return 0;
  }

  ngOnInit () {
  }

  applyFilter (filterValue: string) {
    this.dataSource.filter = filterValue.trim().toLowerCase();

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  openDialog (entity) {

    let dialogRef = this.dialog.open(SubscriptionDialogComponent, {
      width: '500px',
      height: '340px',
      panelClass: 'custom-dialog-container',
      data: entity
    });

    dialogRef.afterClosed()
      .subscribe(response => {
        if (!response) {
          return;
        }

        const actionType: string = response[ 0 ];
        const form: FormGroup = response[ 1 ];

        let formData: any = form.getRawValue();

        if (actionType == 'update') {
          let entity: any = this.createEntity(formData);
          console.log("entity update: " + JSON.stringify(entity));


          this._subscriptionsService.update(entity)
            .then(() => {
              this.snackBar.openSnackBar("Sucesso!", '', 'success');
            })
            .catch((error) => {
              console.log("inscrição update error: " + JSON.stringify(error))
            })

        }

      });
  }

  createEntity (data: any): any {
    let entity: any = {};
    entity.id = data.id;
    entity.member_name = data.name;
    entity.member_email = data.email;
    entity.member_cpf = data.cpf;
    return entity;
  }

  exportToCsv (all) {

    let data: any[];

    let csvFile: any[] = []

    if (all) {
      data = this.dataSource.data;
      csvFile.push("" + ";" + "Inscrições Stream" + '\r\n')
    } else {
      data = this.dataSourceStaff.data;
      csvFile.push("" + ";" + "Inscrições Palestrantes Stream" + '\r\n')
    }

    let csvHeader: string;
    csvHeader = "" + ";"
    if (!all) {
      csvHeader += 'Evento' + ';'
    }

    csvHeader += 'Nome' + ';'
    csvHeader += 'Email' + ';'
    csvHeader += 'CPF' + '\r\n'

    csvFile.push(csvHeader)

    data.forEach((item) => {

      let csvLine: string;
      csvLine = "" + ";"

      if (!all) {
        csvLine += (item.event || '') + ";";
      }

      csvLine += (item.name || '') + ";";
      csvLine += (item.email || '') + ";";
      csvLine += (item.cpf || '') + "\r\n";

      csvFile.push(csvLine)

    })

    var BOM = "\ufeff";
    let csvData = BOM + csvFile;

    var blob = new Blob([ csvData ], {type: "text/csv;charset=utf-8"});

    if (all) {
      this._fileService.saveFile(blob, "inscrições_stream.csv");
    } else {
      this._fileService.saveFile(blob, "inscrições_palestrantes_stream.csv");
    }

  }

}
